import { getSystemInfo } from "@tarojs/taro";
import { useState } from "react";
import { useMounted } from "../hooks/index.js";
const INITIAL_RECT = {
    screenHeight: 0,
    screenWidth: 0,
    windowHeight: 0,
    windowWidth: 0,
};
export function getSystemRect() {
    return getSystemInfo().then(({ screenHeight, screenWidth, windowHeight, windowWidth }) => ({
        screenHeight,
        screenWidth,
        windowHeight,
        windowWidth,
    }));
}
export function useSystemRect() {
    const [rect, setRect] = useState(INITIAL_RECT);
    useMounted(() => getSystemRect().then(setRect));
    return rect;
}
